<template>
  <b-modal
    id="delete-retailer-modal-doorder"
    centered
    modal-class="modal-doorder mt-0"
  >
    <div class="d-block mb-4">
      <p class="confirmMessageModalP message-modal-doorder my-4">
        Are you sure to delete this retailer?
      </p>
    </div>
    <template class="justify-content-center mt-5" #modal-footer>
      <b-row class="justify-content-center w-100">
        <b-col lg="4" md="6" class="text-center">
          <b-button
            type="button"
            variant="doorder-primary"
            class="w-100 btn-bumblebee btn-doorder btn-doorder-submit"
            @click="clickConfirmDelete"
          >
            Yes
          </b-button>
        </b-col>

        <b-col lg="4" md="6" class="text-center">
          <b-button
            type="button"
            variant="doorder-danger-outline "
            class="w-100 btn-bumblebee btn-doorder btn-doorder-submit"
            @click="closeModalDelete"
          >
            Cancel
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>


<script>
import $ from "jquery";
import axios from "axios";

export default {
  name: "DeleteRetailerModal",
  props: ["retailer_id"],
  data() {
    return {
      client_name: "DOORDER",
     
      is_loading: false,
    };
  },
  mounted() {},
  methods: {
    closeModalDelete() {
      this.$bvModal.hide("delete-retailer-modal-doorder");
    },
    clickConfirmDelete() {
      console.log("submit delete retailer ", this.retailer_id);
      
      this.is_loading = true;
      let formData = new FormData();
      formData.append("client", this.client_name);
      formData.append("id", this.retailer_id);

      axios
        .post("retailer/delete", formData, {
          headers: {
            client: this.client_name,
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: response.data.message,
            type: "success",
            customClass: {
              container: "swal-alert-doorder",
              confirmButton:
                "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
              cancelButton:
                "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
          this.is_loading = false;
          this.$bvModal.hide("delete-retailer-modal-doorder"); 
          this.$parent.getAcceptedRetaailers()

        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            customClass: {
              container: "swal-alert-doorder",
              confirmButton:
                "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
              cancelButton:
                "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/doorder/retailers/DeleteRetailerModel.vue